import {
  baseQuery,
  transformErrorResponse,
  transformRequest,
  transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getCookie } from '@/utils';
import { RegistrationUtils } from '@/pages/registration/utils/common';

const authapi = createApi({
  reducerPath: "authapi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({

    login: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/login`,
        method: 'POST',
        body: transformRequest(requestData),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    verifyOtpLogin: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/verify-otp-login`,
        method: 'POST',
        body: transformRequest(requestData),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    forgotPassword: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/forgot-password`,
        method: 'POST',
        body: transformRequest(requestData),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    onBoard: builder.query({
      query: (arg) => ({
        url: `/auth/student/onboard`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME)}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    sendOtp: builder.query({
      query: (requestData) => ({
        url: `/auth/student/send-otp`,
        method: 'POST',
        body: transformRequest(requestData),
        headers: {
          ...(getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME) && {
            Authorization: `Bearer ${getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME)}`,
          }),
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    verifyOtp: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/verify-otp`,
        method: 'POST',
        body: transformRequest(requestData),
        headers: {
          ...(getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME) && {
            Authorization: `Bearer ${getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME)}`,
          }),
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    createPassword: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/set-password`,
        method: 'POST',
        body: transformRequest(requestData),
        headers: {
          Authorization: `Bearer ${getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME)}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    resetPassword: builder.mutation({
      query: (requestData) => ({
        url: `/auth/student/set-password`,
        method: 'PUT',
        body: transformRequest(requestData),
        headers: {
          Authorization: `Bearer ${getCookie(RegistrationUtils.REGISTRATION_COOKIE_NAME)}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    createDigilockerPassword: builder.mutation({
      query: (requestData) => ({
        url: `/auth/digilocker/set-password`,
        method: 'POST',
        body: transformRequest(requestData),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    digilockerVerify: builder.mutation({
      query: (requestData) => ({
        url: `/auth/digilocker/response?code=${requestData?.code}&state=${requestData?.state}${requestData?.type ? `&type=${requestData.type}` : ""}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    digilockerSave: builder.mutation({
      query: (requestData) => ({
        url: `/auth/digilocker/save`,
        method: "POST",
        body: transformRequest(requestData),
        headers: {
          Authorization: `Bearer ${getCookie("AuthUser").token}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    getAttendanceProfileDashboard: builder.query({
      query: () => ({
        url: `/s-lams/attendance/profile-dashboard`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getCookie("AuthUser")?.token || ''}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    getSkillPassportProfile: builder.query({
      query: () => ({
        url: `ssp/student/dashboard`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getCookie("AuthUser")?.token || ''}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
    getMobileAppMenus: builder.query({
      query: () => ({
        url: `/util/quick-service/web`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getCookie("AuthUser")?.token || ''}`,
        },
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse
    }),
  }),
});

export const {
  useLoginMutation, useVerifyOtpLoginMutation, useForgotPasswordMutation, useLazyOnBoardQuery,
  useLazySendOtpQuery, useVerifyOtpMutation, useCreatePasswordMutation,
  useCreateDigilockerPasswordMutation, useDigilockerVerifyMutation,
  useResetPasswordMutation, useDigilockerSaveMutation,
  useGetAttendanceProfileDashboardQuery, useLazyGetAttendanceProfileDashboardQuery,
  useGetSkillPassportProfileQuery,
  useGetMobileAppMenusQuery, useLazyGetMobileAppMenusQuery
} = authapi;

export default authapi;

